<script setup lang="ts">
import { XButton, XIcon, XBadge, XTooltip } from '@clicksign/excalibur';

export type DocumentSumarizeActionProps = {
  floating?: boolean;
};

const props = defineProps<DocumentSumarizeActionProps>();

const emit = defineEmits(['click']);

const handleClick = (event: MouseEvent) => emit('click', event);
</script>

<template>
  <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
  <div
    v-if="props.floating"
    :class="$style.aiFloatingAction"
  >
    <XTooltip
      placement="left"
      is-open
    >
      <span>{{ 'Resumir documento com IA' }}</span>

      <template #activator>
        <XButton
          model="plain"
          :class="$style.button"
          data-testid="aiAction"
          @click="handleClick"
        >
          <XIcon icon="sparkles" />
        </XButton>
      </template>
    </XTooltip>
  </div>

  <XButton
    v-else
    :class="$style.aiAction"
    data-testid="notFloatingAiAction"
    model="plain"
    @click="handleClick"
  >
    <div :class="$style.aiActionContent">
      <span :class="$style.forceColors">
        <XIcon
          icon="sparkles"
          :class="$style.icon"
          left
        />
        <span> {{ 'Resumir com IA' }} </span>
      </span>

      <XBadge
        text-color="var(--color-neutral-0)"
        color="var(--color-feedback-info-400)"
        small
        :class="$style.betaTag"
      >
        {{ $t('common.feature.beta') }}
        <XIcon icon="gem" />
      </XBadge>
    </div>
  </XButton>
</template>

<style lang="scss" module>

.aiAction {

  --border-width: 2px;
  position: relative;
  height: var(--xButton-size);
  padding: 0 var(--space-regular);
  color: var(--color-brand-support-01-600);

  // background: linear-gradient(41.58deg, #F25924 16.05%, #C100FF 86.09%);

  .aiActionContent {
    z-index: 1;
  }

  .forceColors {
    position: relative;
    color: black;
    background: white;

    &::after {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      content: '';
      background: linear-gradient(3deg, #F25924 28.05%, #C100FF 70.09%);
      mix-blend-mode: lighten;
      pointer-events: none;
    }
  }

  // color: transparent;

  &::after {
    position: absolute;
    top: var(--border-width);
    right: var(--border-width);
    bottom: var(--border-width);
    left: var(--border-width);
    content: "";

    // background: linear-gradient(90deg, rgba(252, 213, 200, 0.4) 0%, rgba(198, 171, 244, 0.4) 100%);
    background-color: var(--color-neutral-0);
    border-radius: inherit;
  }

  &:hover {
    box-shadow: var(--shadow-large-x);
  }

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: "";
    background: linear-gradient(3deg, #F25924 28.05%, #C100FF 70.09%);
    border-radius: inherit;
  }

  .betaTag {
    margin-left: var(--space-small-xx);
    color: var(--color-neutral-0);
  }
}

.aiFloatingAction {
  position: fixed;
  z-index: var(--zindex-fixed);
  right: var(--space-regular);
  bottom: var(--space-large);

  .button {
    width: var(--space-large-xx);
    height: var(--space-large-xx);
    color: var(--color-neutral-0);
    background: linear-gradient(41.58deg, #F25924 16.05%, #C100FF 86.09%);
    box-shadow: var(--shadow-large-x);
  }

  @include breakpoint('medium') {
    bottom: var(--space-large);
  }
}
</style>
